var slider = {
    index: 0,
    total: $('.tp-widget-review').length,
    width: 266,
    init: function() {
        $('.tp-widget-review-next').on('click', function() {
            slider.move('next');

        });

        $('.tp-widget-review-prev').on('click', function() {
            slider.move('prev');
        });
    },
    move: function(direction) {
        var overview = $('.tp-widget-reviews'),
            element = $('.tp-widget-review');

        overview.animate({
            left: (direction === 'next' ? -slider.width : slider.width)
        }, 400, function() {
            overview.css('left', 0);

            if (direction === 'next') {
                element.eq(0).parent().append(element.eq(0));
            } else {
                var i = slider.total - 1;
                element.eq(i).parent().prepend(element.eq(i));
            }
        });
    }
};
